import { setUser } from '.';
import { prepareUser } from '../../mappers/prepareUser';
import { resolveUser } from '../../services/user';
import { TUser } from '../../types/currentUser';
import { TThunkAction } from '../../types/redux/thunk';

export function getUserAction(): TThunkAction<Promise<TUser | undefined>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger, config } = context;
    const state = getState();
    const user = await resolveUser({ config, httpApi, logger, subdomain: state.subdomain });
    const mappedUser = prepareUser(user);
    dispatch(setUser(mappedUser));

    return mappedUser;
  };
}
